import React from "react";
import emptyLinkedClient from "../../assets/images/svg/emptyLinkedClient.svg";

import Header from "../../components/Header/Header";
import { useNavigate } from "react-router";
import { logout } from "../../utils/functions";
import { useEffect } from "react";
import UserStore from "../../store/UserStore";
import { useRef } from "react";
import PageHeading from "../../components/PageHeading/PageHeading";

const NoLinkedClients = () => {
  const navigate = useNavigate();
  const navigateRef = useRef();
  const userstoreHydrated = UserStore.isHydrated;

  const navigateUser = () => {
    if (UserStore.linkedClients) {
      navigate("/not-found");
    }
  };
  navigateRef.current = navigateUser;
  useEffect(() => {
    if (UserStore.isHydrated) {
      navigateRef.current();
    }
  }, [userstoreHydrated]);

  return (
    <>
      <Header isLogoNavigationEnabled={false} />
      <div className="outer">
        <div className="main_div">
          <PageHeading headingClass="title" headingText="Linked Clients" />
          <div className="e_image">
            <img src={emptyLinkedClient} alt="No Linked User" />
          </div>
          <div className="status">
            <p className="status_head">There are no clients assigned to you.</p>
            <p className="status_containt">
              Please contact your client and request for access.
            </p>
          </div>
          <div
            className="backButton no_liaison_btn_animation"
            onClick={() => {
              logout();
              navigate("/");
            }}
          >
            <button className="btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
              >
                <path
                  d="M7.99988 0L9.87988 1.88L3.77322 8L9.87988 14.12L7.99988 16L-0.000117302 8L7.99988 0Z"
                  fill="#03002F"
                />
              </svg>
            </button>{" "}
            <p className="btn_title">Go Back</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoLinkedClients;
